import React from "react";
import "./editInfo.css";

import InputBox from "../../commonComponents/inputComponents/InputBox";
import DateSelector from "../../commonComponents/inputComponents/DateSelector";
import { useRef, useState } from "react";

import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../contexts/AuthContext";

import { toast } from "react-toastify";

import Loader from "../../commonComponents/Loader/Loader";

export default function EditInfo() {
  const [isLoading, setIsLoading] = useState(false);

  const { navigate } = useNavigate();

  const { currentUser, updateInfo } = useAuth();

  const nameRef = useRef();
  const phoneRef = useRef();

  async function handleChangeInfoSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    const Name = nameRef.current.value;
    const Phone = phoneRef.current.value;

    if (!Name || !Phone) {
      setIsLoading(false);
      return toast.error("لطفا اطلاعات را وارد کنید");
    }

    if (isNaN(Phone)) {
      setIsLoading(false);
      return toast.error("لطفا شماره موبایل صحیح را وارد کنید");
    }

    const data = {
      name: Name,
      phone: Phone,
    };

    let response;
    try {
      response = await updateInfo(data);
    } catch (error) {
      toast.error(error);
      setIsLoading(false);
      return;
    }
    setIsLoading(false);
    toast.success("تغییرات با موفقیت ذخیره شد");
    navigate("/dashboard/");
  }

  return (
    <div className="info-container">
      <form action="" onSubmit={handleChangeInfoSubmit}>
        <InputBox
          width="47%"
          gap="0px"
          label="نام و نام خانوادگی"
          name="fullName"
          defaultValue={currentUser ? currentUser.name : ""}
          ref={nameRef}
        />
        <InputBox
          width="47%"
          gap="0px"
          label="شماره موبایل"
          name="phoneNumber"
          defaultValue={currentUser ? currentUser.mobile : ""}
          ref={phoneRef}
        />
        <DateSelector
          width="47%"
          gap="0px"
          defaultValue={currentUser ? currentUser.birthday : ""}
          disabled={true}
          ref={undefined}
        />

        <button
          className="edit-info-submit red-submit-btn"
          disabled={isLoading}
        >
          {isLoading ? <Loader loading={isLoading} small dark /> : "ویرایش"}
        </button>
      </form>
    </div>
  );
}
